class NappiUrgency extends HTMLElement {
  static KEY = "nappi:urgency-deadline";
  connectedCallback() {
    const seconds = parseInt(this.dataset.seconds, 10);
    this.output = this.querySelector("[data-urgency-time]");
    this.ends = this.querySelector(".nappi-product__urgency-ends");
    if (!this.output || !Number.isFinite(seconds) || seconds <= 0) {
      this.#masquerCompteur();
      return;
    }
    this.seconds = seconds;
    this.deadline = this.#deadline(seconds);
    this.#tick();
    this.interval = setInterval(() => this.#tick(), 1e3);
  }
  disconnectedCallback() {
    clearInterval(this.interval);
  }
  #masquerCompteur() {
    if (this.ends) this.ends.hidden = true;
  }
  #deadline(seconds) {
    let stored = null;
    try {
      stored = sessionStorage.getItem(NappiUrgency.KEY);
    } catch (e) {
    }
    const parsed = stored ? parseInt(stored, 10) : NaN;
    if (Number.isFinite(parsed) && parsed > Date.now()) return parsed;
    const fresh = Date.now() + seconds * 1e3;
    try {
      sessionStorage.setItem(NappiUrgency.KEY, String(fresh));
    } catch (e) {
    }
    return fresh;
  }
  #tick() {
    const left = Math.max(0, Math.round((this.deadline - Date.now()) / 1e3));
    const h = String(Math.floor(left / 3600)).padStart(2, "0");
    const m = String(Math.floor(left % 3600 / 60)).padStart(2, "0");
    const s = String(left % 60).padStart(2, "0");
    this.output.textContent = `${h}:${m}:${s}`;
    if (left === 0) {
      try {
        sessionStorage.removeItem(NappiUrgency.KEY);
      } catch (e) {
      }
      this.deadline = this.#deadline(this.seconds);
    }
  }
}
if (!customElements.get("nappi-urgency")) {
  customElements.define("nappi-urgency", NappiUrgency);
}
